<!--
 * @Author: xiaokun
 * @Date: 2020-06-09 21:36:29
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-16 11:32:24
 * @Description: 执行效果
-->
<template>
  <div class="execute-result">
    <div class="export-btn-wrapper">
      <export-xlsx
        :api="taskSalesStatisticsClueExportGet"
        text="导出访问用户明细"
        type="default"
        width="140px"
        icon="el-icon-download"
      />
      <export-xlsx
        :api="taskSalesStatisticsExportGet"
        text="导出执行效果"
        type="default"
        width="120px"
        icon="el-icon-download"
      />
    </div>
    <!-- 员工明细 -->
    <div
      v-if="salePartake.length > 0"
      class="sale-details"
    >
      <!-- 标题 -->
      <div class="sale-details-title sale-details-common">
        <div class="sale-name">
          员工
        </div>
        <div class="sale-phone-number">
          电话号码
        </div>
        <div class="sale-visit-num">
          访问人数
        </div>
      </div>
      <!-- 员工表格 -->
      <div
        v-for="saleItem in salePartake"
        :key="saleItem.UserID"
        class="sale-details-content"
      >
        <div class="sale-item sale-details-common">
          <div class="sale-name ellipsis">
            {{ saleItem.name }}
          </div>
          <div class="sale-phone-number">
            {{ saleItem.phone }}
          </div>
          <div class="sale-visit-num">
            <span class="num">{{ formatNum(saleItem.attachCount) }}</span>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <mk-pagination
        small
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        :pager-count="5"
        @current-change="currentChange"
      >
      </mk-pagination>
    </div>
    <div
      v-else
      class="no-data"
    >
      <div class="no-data-img">
        <img
          src="@/assets/images/no-data.png"
          class="img"
        >
      </div>
      <div class="no-data-txt">
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExecuteResult',
  components: {},
  props: {},
  data () {
    return {
      // 销售参与数据
      salePartake: [],
      total: 0,

      page: 1,
      pageSize: 10
    }
  },
  computed: {
    // 导出访问用户明细api
    taskSalesStatisticsClueExportGet () {
      return {
        name: MKMATERIALSVC.TimingplanTaskApi.taskSalesStatisticsClueExportGet,
        params: {
          planId: this.$route.query.id
        }
      }
    },
    // 导出执行效果api
    taskSalesStatisticsExportGet () {
      return {
        name: MKMATERIALSVC.TimingplanTaskApi.taskSalesStatisticsExportGet,
        params: {
          planId: this.$route.query.id
        }
      }
    }
  },
  created () {
    this.getSalePartake()
  },
  methods: {
    formatNum (str) {
      // 每三位加逗号
      return str
    },
    // 销售参与情况
    async getSalePartake () {
      const res = await BIZAPIS.StatisticsApi.timingPlanSalesStatisticsGet({
        planId: this.$route.query.id,
        page: this.page,
        pageSize: 10
      })
      if (res.success) {
        this.total = res.data.total
        this.salePartake = res.data.data
      }
    },
    // 分页
    currentChange (val) {
      this.page = val
      // 调用接口
      this.getSalePartake()
    }
  }
}
</script>
<style lang='scss' scoped>
.execute-result {
  padding: 0 20px;

  .export-btn-wrapper {
    margin: 10px 0;
  }

  .sale-details {
    .sale-details-title {
      color: #475166;
      font-size: 12px;
      margin-top: 8px;
      font-weight: 500;
      line-height: 17px;
    }

    .sale-details-common {
      display: flex;
      justify-content: space-between;
    }

    .sale-item {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      line-height: 20px;
      color: #595959;
      font-size: 13px;
    }

    .sale-name {
      width: 120px;
    }

    .sale-phone-number {
      width: 137px;
    }

    .sale-visit-num {
      min-width: 48px;
      text-align: right;
    }

    .sale-status {
      display: flex;
      align-items: center;
      min-width: 60px;

      .status-spot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 4px;
      }
    }

    /deep/ .el-pagination {
      margin-top: 10px;
      color: #8c8c8c;
      text-align: right;
      font-weight: normal;
    }
  }

  .no-data {
    text-align: center;
    font-size: 14px;
    line-height: 14px;
    padding: 110px 0;
    color: #bfbfbf;

    .no-data-img {
      margin-bottom: 8px;

      img {
        width: 80px;
      }
    }
  }
}
</style>
